import React from 'react';
import { Box, Skeleton } from '@mui/material';

function OncologySkeleton() {
  return (
    <Box className="box-sizing-border-box oncology-box">
            <Box className="flex-row-space-between-center gap-4">
                <Box>
                    <Skeleton variant="text" width={100} height={20} />
                </Box>
                <Box>
                    <Skeleton variant="text" width={20} height={20} />
                </Box>
            </Box>
            <Box className="flex-row-space-between">
                <Box>
                    <Skeleton variant="text" width={50} height={32} />
                </Box>
                <Box>
                    <Box className="flex-row gap-4">
                        <Skeleton variant="text" width={16} height={16} />
                        <Skeleton variant="text" width={30} height={18} />
                    </Box>
                    <Skeleton variant="text" width={70} height={18} />
                </Box>
            </Box>
        </Box>
  )
}

export default OncologySkeleton